module.exports = __webpack_public_path__ + "img/wasabi.3c9cf5f9.png";